<!-- <div class="container-fluid px-0">
    <div class="bg-image"></div>
    <div class="reset-box">
     <div class="card" style="width: 18rem; border-radius: 0;">
         <div class="card-body">
           <h5 class="card-title top-heading">Forgot your Password?</h5>
           <h6 class="card-subtitle mb-2 text-muted">Enter your email address and we'll send you a link  to reset  your password.</h6>
           <form #forgetPasswordForm="ngForm">
             
             <div class="form-group py-2">
               <input type="email" class="form-control"[(ngModel)]="email" #emailName="ngModel" [class.is-invalid]="emailName.touched && emailName.invalid" id="emailaddress01" placeholder="Email Address" name="emailID" required email (ngModelChange)="flag=''">
               <div id="emailaddress01Feedback" class="invalid-feedback" >
                Please provide a valid email.
              </div>
              </div>
              <div class="alert" [class]="flag" role="alert" *ngIf ="flag!=''">
                  {{alertMessage}}
                </div>
             <button type="submit" class="btn btn-outline-secondary button-white mx-1" [routerLink]="['/login']">Cancel</button>
             <button type="submit" class="btn btn-secondary button-oranged mx-1" [disabled]="forgetPasswordForm.status == 'INVALID'"(click)="updatePassword()" >Submit</button>
             
           </form>
           
         </div>
       </div>
  </div>
</div>
 -->

 <div class="container-fluid auth">
  <div class="row p-4">
    <img src="assets/img/Logo.svg" class="logo">
  </div>
  <div class="container auth-box">
    <div class="row align-items-center">
      <div class="col-md-6">
        <h2>Forgot Password!</h2>
        <h4>It's human nature to forget! Please enter the details below and we shall recover it for you.</h4>
        <form [formGroup]="forgotForm" (ngSubmit)="updatePassword()" class="mt-3">
          <div class="input-field">
            <mat-form-field appearance="outline">
              <mat-label>Email Address</mat-label>
              <input type="text" matInput formControlName="emailAddress" autocomplete="off"
                [errorStateMatcher]="matcher">
              <mat-error *ngIf="forgotForm.get('emailAddress').hasError('required')">
                Email Address is required
              </mat-error>
              <mat-error *ngIf="forgotForm.get('emailAddress').hasError('email')">
                Please enter a valid Email Address
              </mat-error>
            </mat-form-field>
          </div>
          <div class="mt-4">
            <button color="accent" mat-raised-button type="submit" class="loading-btn w-100"
              [disabled]="isLoading">Submit
              <mat-icon matSuffix *ngIf="isLoading"><mat-spinner diameter="18"></mat-spinner></mat-icon>
            </button>
          </div>
          <div class="d-flex justify-content-center mt-3">
            <a mat-button color="primary" disableRipple [routerLink]="['/login']">Back to Login</a>
          </div>
        </form>
      </div>
      <div class="col-md-6">
        <img src="assets/img/bg-forgot.png" class="w-100 pl-3"/>
      </div>
    </div>
  </div>
</div>